import React, { FC, HTMLAttributes } from "react";
import { elAnchorButton, elAnchorButtonWhite, ElBanner, ElBannerContent, ElBannerImageCircle, ElBannerImageMain, ElColumn, ElColumnSubs, elGapBanner } from "./banner.css";
import { Container } from "../../layout";
import { Link } from "react-router-dom";
import { Images } from "../../../@assets/images";
import { ElHeadLine } from "../head-title";
interface IBannerProps extends HTMLAttributes<HTMLElement> {
  title: string;
  subTitle: string;
  img: string;
  hashTag?: string;
  link: {
    create: string;
    eplore: string;
  };
}

export const Banner: FC<IBannerProps> = ({ children, title, subTitle, img, ...props }) => {
  const style = props.hashTag ? { "--hashTag": `"${props.hashTag}"` } : {};
  return (
    <ElBanner {...props}>
      <ElBannerImageCircle src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/cicrcle.png' />
      <Container className={elGapBanner}>
        <ElBannerContent>
          <ElColumn>
            <ElHeadLine style={style}>{title}</ElHeadLine>
            <h3>{subTitle}</h3>
            <ElColumnSubs>
              <Link to="#" onClick={props.link.goToTimeline} className={elAnchorButton}>
                Explore Program
              </Link>
              <Link to={props.link.create} target="_blank" className={elAnchorButtonWhite}>
                Daftar Sekarang
              </Link>
            </ElColumnSubs>
          </ElColumn>
          <ElColumn>
            <ElBannerImageMain src={img} />
          </ElColumn>
        </ElBannerContent>
      </Container>
    </ElBanner>
  );
};
